/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sanction_Sub_Rage_QuittingInputs */



/**
* | output |
* | --- |
* | "Rage Quitting" |
*
* @param {Sanction_Sub_Rage_QuittingInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_sub_rage_quitting = /** @type {((inputs?: Sanction_Sub_Rage_QuittingInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_Sub_Rage_QuittingInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rage Quitting")
	if (locale === "es") return /** @type {LocalizedString} */ ("Abandono por Ira")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Desistência por Raiva")
	if (locale === "it") return /** @type {LocalizedString} */ ("Abbandono per Rabbia")
	return /** @type {LocalizedString} */ ("Rage Quitting")
});